import { atom } from "recoil";

export const homePageAtom = atom({
  key: "homePageAtom",
  default: [],
});
